<template>
	<div>
		<pui-datatable
			:modelName="modelName"
			:actions="actions"
			:modelColumnDefs="modelColumnDefs"
		></pui-datatable>
		<mgrupoenvasado-modals
			:modelName="modelName"
		></mgrupoenvasado-modals>
	</div>
</template>

<script>
import mgrupoenvasadoActions from './MgrupoenvasadoActions';
import mgrupoenvasadoModals from './MgrupoenvasadoModals.vue';

export default {
	name: 'mgrupoenvasado-grid',
	components: {
		'mgrupoenvasado-modals': mgrupoenvasadoModals
	},
	data() {
		return {
			modelName: 'mgrupoenvasado',
			actions: mgrupoenvasadoActions.gridactions,
			modelColumnDefs: {
			}
		}
	}
}
</script>
